var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVeryDissatisfied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4,
    cy: 12,
    r: 9,
    fill: "#FFB26A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9 11C16.728 11 17.4 10.328 17.4 9.5C17.4 8.672 16.728 8 15.9 8C15.072 8 14.4 8.672 14.4 9.5C14.4 10.328 15.072 11 15.9 11Z",
    fill: "#1A1B43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89999 11C9.72799 11 10.4 10.328 10.4 9.5C10.4 8.672 9.72799 8 8.89999 8C8.07199 8 7.39999 8.672 7.39999 9.5C7.39999 10.328 8.07199 11 8.89999 11Z",
    fill: "#1A1B43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.744 17.001C16.354 17.001 15.984 16.772 15.823 16.39C15.284 15.118 13.909 14.263 12.401 14.263C10.893 14.263 9.51698 15.118 8.97798 16.39C8.76298 16.898 8.17398 17.136 7.66698 16.921C7.15798 16.706 6.91998 16.119 7.13598 15.61C7.99698 13.576 10.063 12.262 12.401 12.262C14.739 12.262 16.804 13.576 17.665 15.61C17.88 16.119 17.643 16.705 17.134 16.921C17.007 16.975 16.875 17.001 16.745 17.001H16.744Z",
    fill: "#1A1B43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.39 2C6.86999 2 2.39999 6.48 2.39999 12C2.39999 17.52 6.86999 22 12.39 22C17.91 22 22.4 17.52 22.4 12C22.4 6.48 17.92 2 12.39 2ZM12.4 20C7.97999 20 4.39999 16.42 4.39999 12C4.39999 7.58 7.97999 4 12.4 4C16.82 4 20.4 7.58 20.4 12C20.4 16.42 16.82 20 12.4 20Z",
    fill: "#1A1B43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVeryDissatisfied);
export default __webpack_public_path__ + "static/media/icon-very-dissatisfied.9e873b82da21214b5d9959e4aa91410e.svg";
export { ForwardRef as ReactComponent };